import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class HelperService {
    constructor() { }
    public validatePassword(value: string) {
        return !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/.test(value);
        // !/^(?=.*[a-zA-Z])(?=.*[0-9]).*$/.test(value);
    }

    public validateSlackUrl(value: string) {
        return /^https:\/\/hooks\.slack\.com\/.+$/.test(value);
    }
    public validateTeamsUrl(value: string) {
        return /^https:\/\/[a-zA-Z0-9.-]+\.webhook\.office\.com\/webhookb2\/[a-f0-9-]+@[a-f0-9-]+\/IncomingWebhook\/[a-f0-9]+\/[a-f0-9-]+\/[a-zA-Z0-9_-]+$/i.test(value);
        //   /^https:\/\/netorgft12338476\.webhook\.office\.com\/.+$/.test(value);
    }
    public validateZapierUrl(value: string) {
        return /^https:\/\/hooks\.zapier\.com\/.+$/.test(value);
    }
}
